module.exports = __webpack_public_path__ + "static/media/Corn6R1.b2062f54.png";